/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Grid, Button } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { ADGMPanel, ADGMPagination, ADGMItemDetails, ADGMImage } from 'aurora-components';

import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

const DEFAULT_PAGE = 1;
const DEFAULT_ITEMS_PER_PAGE = 5;

const PropertiesListingWithModal = ({
  classes,
  data,
  itemsPerPage,
  totalPages,
  helpersButtons,
  onPageChange,
  customClasses,
  ...panelProps
}) => {
  if (isEmpty(data)) return null;
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('xs'));
  const { locale } = useSelector(state => state.language);

  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
  const handlePageChange = page => {
    setCurrentPage(page);
    onPageChange && onPageChange(page);
  };
  const PLOT_ID = 1;

  const PLOT_LABELS = [
    {
      label: 'plot_number',
      valueProperty: 'plotNumber',
      showInMobileView: true,
    },
    {
      label: 'municipality',
      valueProperty: 'municipalityNameEn',
      valuePropertyAr: 'municipalityNameAr',
      showInMobileView: true,
    },
    {
      label: 'district',
      valueProperty: 'districtNameEn',
      valuePropertyAr: 'districtNameAr',
    },
    {
      label: 'community',
      valueProperty: 'communityNameEn',
      valuePropertyAr: 'communityNameAr',
    },
  ];
  const UNIT_LABELS = [
    {
      label: 'building_name_number',
      valueProperty: 'buildingNumber',
      showInMobileView: true,
    },

    {
      label: 'unit_number',
      valueProperty: 'unitNumber',
      showInMobileView: true,
    },
    {
      label: 'Floor',
      valueProperty: 'floorNumber',
    },
    {
      label: 'unit_type',
      valueProperty: 'buildingUsageEn',
      valuePropertyAr: 'buildingUsageAr',
    },
  ];

  return (
    <ADGMPanel
      hasPadding
      {...panelProps}
      classes={{
        containerPadding: classes.containerPadding,
      }}
    >
      <div className={classNames(classes.dataContainer, customClasses?.listContainer)}>
        {isArray(data) &&
          data?.map((property, index) => (
            <Grid container spacing={2} alignItems='center' key={index} className={classes.propertyRow}>
              <Grid item xs='auto' className={classes.alignSelfStart}>
                <ADGMImage
                  className={classes.propertyListingImage}
                  name={property?.propertyType === PLOT_ID ? 'land_property.svg' : 'PropertyDetails-Unit.svg'}
                />
              </Grid>

              <Grid item xs>
                <Grid container spacing={2} justifyContent='space-between'>
                  {(property.propertyType === PLOT_ID ? PLOT_LABELS : UNIT_LABELS)
                    ?.filter(label => !mobileView || label.showInMobileView)
                    .map(label => (
                      <Grid item sm={3}>
                        <ADGMItemDetails
                          label={label.label}
                          value={locale === 'ar' ? property[label.valuePropertyAr] : property[label.valueProperty]}
                        />
                      </Grid>
                    ))}
                </Grid>
              </Grid>

              <Grid item xs={2}>
                <div className={classes.helperButtonsContainer}>
                  {helpersButtons?.map(
                    ({ title, handler, icon, hidden = () => false }) =>
                      !hidden(property.plotId) && (
                        <Button className={classes.helperBtn} onClick={() => handler(property)}>
                          {icon} {!mobileView && keyEmptyCheck(title)}
                        </Button>
                      ),
                  )}
                </div>
              </Grid>
            </Grid>
          ))}
      </div>
      {isArray(data) && (
        <div className={classNames(classes.paginationContainer, customClasses.paginationContainer)}>
          <ADGMPagination totalPages={totalPages} currentPage={Number(currentPage)} onPageChange={handlePageChange} />
        </div>
      )}
    </ADGMPanel>
  );
};

PropertiesListingWithModal.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  itemsPerPage: PropTypes.number,
  customClasses: PropTypes.object,
  helpersButtons: PropTypes.array,
  onPageChange: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
};

PropertiesListingWithModal.defaultProps = {
  itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
  customClasses: {},
  helpersButtons: [],
};

export default withStyles(styles)(PropertiesListingWithModal);
